import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api"; // ✅ use your shared axios client

function AddPart() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    part_id: "",
    line: "",
    machine: "",
    equipment: "",
    part_name: "",
    quantity: 0,
    location: "",
  });

  const lines = [
    "Line A", "Line B", "Line C", "Line D", "Shirataki", "Juten",
    "1Gal", "Fryer", "Multivac", "Building", "Production", "SQF",
    "Okara", "Recieving", "Soaking", "Casing", "Other",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "quantity"
          ? value === "" ? "" : Number(value)
          : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      quantity: Number(formData.quantity || 0),
    };

    try {
      await api.post("/api/parts", payload);
      alert("✅ Part added successfully!");
      navigate("/parts");
    } catch (err) {
      console.error("Error adding part", err);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err.message ||
        "Unknown error";
      alert(`❌ Failed to add part: ${msg}`);
    }
  };

  return (
    <div className="main-content">
      <h1>➕ Add Part</h1>

      <form onSubmit={handleSubmit}>
        <div>
          <label>Part ID:</label>
          <input
            name="part_id"
            value={formData.part_id}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Line:</label>
          <select
            name="line"
            value={formData.line}
            onChange={handleChange}
            required
          >
            <option value="">Select Line</option>
            {lines.map((l) => (
              <option key={l} value={l}>
                {l}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Machine:</label>
          <input
            name="machine"
            value={formData.machine}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Equipment:</label>
          <input
            name="equipment"
            value={formData.equipment}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Part Name:</label>
          <input
            name="part_name"
            value={formData.part_name}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Quantity:</label>
          <input
            type="number"
            name="quantity"
            value={formData.quantity}
            onChange={handleChange}
            min="0"
            required
          />
        </div>

        <div>
          <label>Location:</label>
          <input
            name="location"
            value={formData.location}
            onChange={handleChange}
          />
        </div>

        <br />
        <button type="submit">Submit Part</button>
      </form>
    </div>
  );
}

export default AddPart;
